module.exports = __webpack_public_path__ + "static/join_honors_obj04@2x-55ae17593f2610ff6c39eb12a157385d.png";